import { createPlugin } from '@backstage/core-plugin-api';
import { createCardExtension } from '@backstage/plugin-home-react';
import { TaskListContentProps } from './Content';

/** @public */
export const taskPlugin = createPlugin({
  id: 'tasks',
  apis: [],
  routes: {},
});

export const HomePageTaskList = taskPlugin.provide(
  createCardExtension<Partial<TaskListContentProps>>({
    name: 'TaskList',
    title: 'Task List',
    components: () => import('./ListTask'),
  }),
);
